<template>
    <div class="anniversary">
      <div class="header clearfix">
        <div class="header-main">
          <span class="fl logo-icon">
            <a href="/"><img class="logo" src="./abc.png" alt="" width="185"></a>
          </span>
          <ul class="fl pt">
              <!-- @click="jump(index)" -->
            <li v-for="(item, index) in navList" :key="index" @click="jump(index)" :class="{'active': isActive === index}">{{item}}
                 <span class="catalogArrow" v-show="isActive === index"></span>
            </li>
            <li class="navlist" @mouseover="mouseoverHandle" @mouseout="mouseoutHandle">
              亚商大家庭 <span></span>
              <transition name="slideToggle">
                <ul class="second-list" v-show="slideDown">
                    <li><a href="http://www.abccapital.cn/" target="_blank"><span></span> 亚商资本</a></li>
                    <li><a href="https://www.abctougu.cn" target="_blank"><span></span> 亚商投顾</a></li>
                </ul>
              </transition>
            </li>
          </ul>
        </div>
      </div>
      <div class="content banner">
      </div>
      <div class="keyWordContent">
          <div class="keywords">
              <div class="tit">
                  <img class="keyWordsImg" src="./keyWords.png" alt="">
                  <img src="./left-line.png" alt="">
                  <span>怀旧 · 赋能 · 活力 · 未来</span>
                  <img src="./right-line.png" alt="">
              </div>
              <div class="info">
                  <img class="symbol1" src="./symbol1.png" alt="">
                  <div class="text">
                  ‘三十而立尘与土，八千里路云和月。’岁月如歌，风霜如画，暮然回首，滚滚红尘，展望前程，云重月明。三十年弹指一挥间，上海亚商发展集团有限公司迎来了30周岁的生日。三十年来，亚商始终与中国资本市场的改革和中国的经济转型紧相随、共发展。亦步亦趋，时起时伏。初夏时节，气候怡人，亚商特集老友新朋举行一场特别的聚会。让我们一起在这个快速变化的世道，怀怀旧，赋赋能，增活力，赢未来！
                  </div>
                  <img class="symbol2" src="./symbol2.png" alt="">
              </div>
              <div class="founder fr">
                  <div class="fr textAlignL">
                      <h1>陈琦伟</h1>
                      <h3>Chen QiWei</h3>
                      <p>亚商集团董事长</p>
                  </div>
                  <img class="photoChen fr" src="./photo-chen.png" alt="">
              </div>
          </div>
          <!-- 主题视频 -->
          <div class="content video clearfix">
              <div class="position row fl">
                  <!-- <embed src="https://imgcache.qq.com/tencentvideo_v1/playerv3/TPout.swf?max_age=86400&v=20161117&vid=b0685qu7shy&auto=0" allowFullScreen="true" quality="high" width="918" height="578" align="middle" allowScriptAccess="always" type="application/x-shockwave-flash" loop="true" onplaying="onplaying"></embed> -->
                  <video controls="controls" width="918" height="578" poster="./video1.jpg" class="video1">
                    <source src="https://media.abc-group.cn/abc-group/30%E5%91%A8%E5%B9%B4%E5%BA%86/video1.ogg" type="video/ogg">
                    <source src="https://media.abc-group.cn/abc-group/30%E5%91%A8%E5%B9%B4%E5%BA%86/video1.webm" type="video/webm">
                    <source src="https://media.abc-group.cn/abc-group/30%E5%91%A8%E5%B9%B4%E5%BA%86/video1.mp4" type="video/mp4">
                  </video>
                  <div class="tips">
                      <p>主题短片</p>
                      <div class="line"></div>
                      <p class="fontBold">亚商“三十而立”视频</p>
                  </div>
              </div>
              <div class="column fr">
                  <div class="position" style="margin-bottom: 10px">
                      <!-- <embed src="https://imgcache.qq.com/tencentvideo_v1/playerv3/TPout.swf?max_age=86400&v=20161117&vid=o0685prwr3z&auto=0" allowFullScreen="true" quality="high" width="498" height="283" align="middle" allowScriptAccess="always" type="application/x-shockwave-flash" loop="true" onplaying="onplaying"></embed> -->
                    <video controls="controls" width="498" height="283" poster="./video2.jpg">
                        <source src="https://media.abc-group.cn/abc-group/30%E5%91%A8%E5%B9%B4%E5%BA%86/video2.ogg" type="video/ogg">
                        <source src="https://media.abc-group.cn/abc-group/30%E5%91%A8%E5%B9%B4%E5%BA%86/video2.webm" type="video/webm">
                        <source src="https://media.abc-group.cn/abc-group/30%E5%91%A8%E5%B9%B4%E5%BA%86/video2.mp4" type="video/mp4">
                    </video>
                    <div class="tips">
                      <p>庆典花絮</p>
                      <div class="line"></div>
                      <p class="fontBold">亚商“30与时共舞”活动视频</p>
                    </div>
                  </div>
                  <div class="position">
                      <!-- <embed src="https://imgcache.qq.com/tencentvideo_v1/playerv3/TPout.swf?max_age=86400&v=20161117&vid=k0724nbaj9g&auto=0" allowFullScreen="true" quality="high" width="498" height="283" align="middle" allowScriptAccess="always" type="application/x-shockwave-flash" loop="true" onplaying="onplaying"></embed> -->
                    <video controls="controls" width="498" height="283" poster="./video3.jpg">
                        <source src="https://media.abc-group.cn/abc-group/30%E5%91%A8%E5%B9%B4%E5%BA%86/video3.ogg" type="video/ogg">
                        <source src="https://media.abc-group.cn/abc-group/30%E5%91%A8%E5%B9%B4%E5%BA%86/video3.webm" type="video/webm">
                        <source src="https://media.abc-group.cn/abc-group/30%E5%91%A8%E5%B9%B4%E5%BA%86/video3.mp4" type="video/mp4">
                    </video>
                    <div class="tips">
                      <p>企业文化</p>
                      <div class="line"></div>
                      <p class="fontBold">陈琦伟教授讲述艺术品</p>
                    </div>
                  </div>
              </div>
          </div>
      </div>
      <!-- 主要嘉宾 -->
      <div class="content guests">
          <div class="guestsMain">
              <div class="tit" style="margin-bottom:0;">
                <img src="./left-line.png" alt="">
                <span>主要嘉宾</span>
                <img src="./right-line.png" alt="">
              </div>
              <ul class="clearfix" id="guestList">
                  <li v-for="(guest,index) in guestList" :key="index">
                    <img class="photo" :src="guest.photo" alt="">
                    <div class="guestIntro">
                        <h2>{{guest.name}}</h2>
                        <p v-for="(item,index) in guest.intro" :key="index">{{item}}</p>
                    </div>
                  </li>
              </ul>
          </div>
      </div>
      <!-- 精彩观点 -->
      <div class="content viewpoint">
          <div class="viewpointMain">
              <div class="tit" style="margin-bottom:0;">
                <img src="./left-line.png" alt="">
                <span>精彩观点</span>
                <img src="./right-line.png" alt="">
              </div>
              <div class="cardBox">
                  <template>
                    <el-carousel :interval="4000" type="card" height="314px">
                        <el-carousel-item v-for="item in cardList" :key="item">
                        <img :src="item" alt="">
                        </el-carousel-item>
                    </el-carousel>
                  </template>
              </div>
          </div>
      </div>
      <!-- 照片实录 -->
      <div class="content picture">
          <div class="pictureMain">
              <div class="tit" style="margin-bottom:0;">
                <img src="./left-line.png" alt="">
                <span>照片实录</span>
                <img src="./right-line.png" alt="">
              </div>
          </div>
          <ul class="tabList">
              <li v-for="(tab,index) in tabList" :key="index" :class="{'activeStyle': index == activeIndex}" @click="clickTabHandle(index)">{{tab}}</li>
          </ul>
          <div class="pictureList">
              <ul>
                  <li v-for="(pic,index) in pictureList[activeIndex]" :key="index">
                      <img :src="pic.url" alt="" @click="scaleImgHandle(pic.id)">
                  </li>
              </ul>
          </div>
      </div>
      <!-- footer -->
      <div class="footer">
          <div class="footer-box">
            <div class="abc-info clearfix">
                <span class="fl logoList">
                    <a href="/"><img src="./abcFooter.png" alt=""></a>
                    <a href="http://www.abccapital.cn/" target="_blank"><img src="./abccapital.png" alt="亚商资本"></a>
                    <a href="https://www.abctougu.cn" target="_blank"><img src="./abcamc.png" alt="亚商投顾"></a>
                </span>
                <span class="fr" style="margin-top: 35px;">Copyright © 1988~2018  亚商集团 ABCGroup <a href="http://www.beian.miit.gov.cn/publish/query/indexFirst.action">沪 ICP 备 09048639 号-2</a> 版权所有</span>
            </div>
          </div>
       </div>
     <!-- 大图轮播 弹出层 -->
      <transition name="fade">
        <div class="mask" v-show="showMask">
            <div class="popup">
                <span class="close" v-show="pictureList[activeIndex][showIndex].bigPic" @click="closePop"></span>
                <img :src="pictureList[activeIndex][showIndex].bigPic" alt="">
                <div class="btn prevBtn" @click="prevBtnClick">&lt;</div>
                <div class="btn nextBtn" @click="nextBtnClick">&gt;</div>
            </div>
        </div>
      </transition>
      <go-top></go-top>
    </div>
</template>
<script>
import goTop from "../../common/go-top.vue";
export default {
    name: 'Anniversary',
    components: {
      goTop
    },
    data(){
        return{
            isActive: 0,
            navList: ['首页', '主题视频', '主要嘉宾', '精彩观点', '照片实录'],
            slideDown: false,
            guestList: [],
            activeIndex: 0, //tab切换
            tabList: ['庆典现场','集体合照','嘉宾照片','乐队演奏','晚宴合集'],
            pictureList: [
                [
                    {
                        id: 0,
                        url: require('./pictures/celebration1.jpg'),
                        bigPic: require('./pictures/celebration1-big.jpg'),
                    },
                    {
                        id: 1,
                        url: require('./pictures/celebration2.jpg'),
                        bigPic: require('./pictures/celebration2-big.jpg'),
                    },
                    {
                        id: 2,
                        url: require('./pictures/celebration3.jpg'),
                        bigPic: require('./pictures/celebration3-big.jpg'),
                    },
                    {
                        id: 3,
                        url: require('./pictures/celebration4.jpg'),
                        bigPic: require('./pictures/celebration4-big.jpg'),
                    },
                    {
                        id: 4,
                        url: require('./pictures/celebration5.jpg'),
                        bigPic: require('./pictures/celebration5-big.jpg'),
                    },
                    {
                        id: 5,
                        url: require('./pictures/celebration6.jpg'),
                        bigPic: require('./pictures/celebration6-big.jpg'),
                    },
                ],
                [
                    {
                        id: 0,
                        url: require('./pictures/collective1.jpg'),
                        bigPic: require('./pictures/collective1-big.jpg'),
                    },
                    {
                        id: 1,
                        url: require('./pictures/collective2.jpg'),
                        bigPic: require('./pictures/collective2-big.jpg'),
                    },
                    {
                        id: 2,
                        url: require('./pictures/collective3.jpg'),
                        bigPic: require('./pictures/collective3-big.jpg'),
                    },
                    {
                        id: 3,
                        url: require('./pictures/collective4.jpg'),
                        bigPic: require('./pictures/collective4-big.jpg'),
                    },
                    {
                        id: 4,
                        url: require('./pictures/collective5.jpg'),
                        bigPic: require('./pictures/collective5-big.jpg'),
                    },
                    {
                        id: 5,
                        url: require('./pictures/collective6.jpg'),
                        bigPic: require('./pictures/collective6-big.jpg'),
                    },
                ],
                [
                    {
                        id: 0,
                        url: require('./pictures/guest1.jpg'),
                        bigPic: require('./pictures/guest1-big.jpg'),
                    },
                    {
                        id: 1,
                        url: require('./pictures/guest2.jpg'),
                        bigPic: require('./pictures/guest2-big.jpg'),
                    },
                    {
                        id: 2,
                        url: require('./pictures/guest3.jpg'),
                        bigPic: require('./pictures/guest3-big.jpg'),
                    },
                    {
                        id: 3,
                        url: require('./pictures/guest4.jpg'),
                        bigPic: require('./pictures/guest4-big.jpg'),
                    },
                    {
                        id: 4,
                        url: require('./pictures/guest5.jpg'),
                        bigPic: require('./pictures/guest5-big.jpg'),
                    },
                    {
                        id: 5,
                        url: require('./pictures/guest6.jpg'),
                        bigPic: require('./pictures/guest6-big.jpg'),
                    },
                ],
                [
                    {
                        id: 0,
                        url: require('./pictures/band1.jpg'),
                        bigPic: require('./pictures/band1-big.jpg'),
                    },
                    {
                        id: 1,
                        url: require('./pictures/band2.jpg'),
                        bigPic: require('./pictures/band2-big.jpg'),
                    },
                    {
                        id: 2,
                        url: require('./pictures/band3.jpg'),
                        bigPic: require('./pictures/band3-big.jpg'),
                    },
                    {
                        id: 3,
                        url: require('./pictures/band4.jpg'),
                        bigPic: require('./pictures/band4-big.jpg'),
                    },
                    {
                        id: 4,
                        url: require('./pictures/band5.jpg'),
                        bigPic: require('./pictures/band5-big.jpg'),
                    },
                    {
                        id: 5,
                        url: require('./pictures/band6.jpg'),
                        bigPic: require('./pictures/band6-big.jpg'),
                    },
                ],
                [
                    {
                        id: 0,
                        url: require('./pictures/dinner1.jpg'),
                        bigPic: require('./pictures/dinner1-big.jpg'),
                    },
                    {
                        id: 1,
                        url: require('./pictures/dinner2.jpg'),
                        bigPic: require('./pictures/dinner2-big.jpg'),
                    },
                    {
                        id: 2,
                        url: require('./pictures/dinner3.jpg'),
                        bigPic: require('./pictures/dinner3-big.jpg'),
                    },
                    {
                        id: 3,
                        url: require('./pictures/dinner4.jpg'),
                        bigPic: require('./pictures/dinner4-big.jpg'),
                    },
                    {
                        id: 4,
                        url: require('./pictures/dinner5.jpg'),
                        bigPic: require('./pictures/dinner5-big.jpg'),
                    },
                    {
                        id: 5,
                        url: require('./pictures/dinner6.jpg'),
                        bigPic: require('./pictures/dinner6-big.jpg'),
                    },
                ],
            ],
            cardList: [
                require('./img/1.png')
                ,require('./img/2.png')
                ,require('./img/3.png')
                ,require('./img/4.png')
                ,require('./img/5.png')
                ,require('./img/6.png')
                ,require('./img/7.png')
                ,require('./img/8.png')
                ,require('./img/9.png')
                ,require('./img/10.png')
                ,require('./img/11.png')
                ,require('./img/12.png')
                ,require('./img/13.png')
                ,require('./img/14.png')
                ,require('./img/15.png')
                ,require('./img/16.png')
            ],
            showMask: false,
            showIndex: 0,
        }
    },
    mounted(){
        this.guestList = this.loadAllGuests();
        this.$nextTick(function(){
        });
    },
    methods:{
        gotoHomePage(){
            let url = window.location.protocol + "//" + window.location.host + '/#/home';
            window.location.href = url;
        },
        begin_playing(){
            console.log('playing');
        },
        //加载所有嘉宾信息列表数据
        loadAllGuests(){
            let arr = [];
            let obj = {};
            arr = [
                {
                    name: '黄奇帆',
                    photo: '',
                    intro: ['第十二届全国人民代表大会财政经济委员会副主任委员','重庆市原市长']
                },
                {
                    name: '王新奎',
                    photo: '',
                    intro: ['上海市人民政府参事室主任','十二届全国政协常委']
                },
                {
                    name: '童世骏',
                    photo: '',
                    intro: ['华东师范大学党委书记']
                },
                {
                    name: '陈显宝',
                    photo: '',
                    intro: ['宅急送快运股份有限公司监事会主席']
                },
                {
                    name: '陈文霆',
                    photo: '',
                    intro: ['乐威医药股份有限公司董事长兼CEO']
                },
                {
                    name: '戴富祺',
                    photo: '',
                    intro: ['上海洛克公园创始人']
                },
                {
                    name: '邓伟利',
                    photo: '',
                    intro: ['上海国际集团资产管理有限公司董事长']
                },
                {
                    name: '杜厦',
                    photo: '',
                    intro: ['家世界集团&太平洋高尔夫联盟创始人']
                },
                {
                    name: '范永进',
                    photo: '',
                    intro: ['上海爱建股份党委书记']
                },
                {
                    name: '冯地',
                    photo: '',
                    intro: ['广州九龙湖房地产开发有限公司董事长']
                },
                {
                    name: '冯仑',
                    photo: '',
                    intro: ['万通控股董事长']
                },
                {
                    name: '桂国杰',
                    photo: '',
                    intro: ['上海中房置业董事长']
                },
                {
                    name: '何启强',
                    photo: '',
                    intro: ['广东长青(集团)股份有限公司董事长']
                },
                {
                    name: '何志光',
                    photo: '',
                    intro: ['上海新华商金控集团总裁']
                },
                {
                    name: '胡柏藩',
                    photo: '',
                    intro: ['浙江新和成股份有限公司董事长']
                },
                {
                    name: '黄开添',
                    photo: '',
                    intro: ['福建莆田商会名誉会长','上海恒奕投资管理有限公司董事长']
                },
                {
                    name: '贾小东',
                    photo: '',
                    intro: ['GALA SPORTS深圳市望尘科技有限公司CEO']
                },
                {
                    name: '李东生',
                    photo: '',
                    intro: ['TCL集团董事长']
                },
                {
                    name: '李钢',
                    photo: '',
                    intro: ['中国保险养老社区联盟会长']
                },
                {
                    name: '李京真',
                    photo: '',
                    intro: ['原上海证券交易所上市部总监']
                },
                {
                    name: '李烈涛',
                    photo: '',
                    intro: ['来恩生物医药公司联合创始人与首席执行官']
                },
                {
                    name: '林中',
                    photo: '',
                    intro: ['旭辉集团董事长']
                },
                {
                    name: '刘向东',
                    photo: '',
                    intro: ['正信银行行长']
                },
                {
                    name: '刘训峰',
                    photo: '',
                    intro: ['上海华谊集团党委书记、董事长']
                },
                {
                    name: '马健',
                    photo: '',
                    intro: ['工银安盛保险董事长']
                },
                {
                    name: '马钦荣',
                    photo: '',
                    intro: ['上海财经大学原党委书记']
                },
                {
                    name: '毛振华',
                    photo: '',
                    intro: ['中诚信集团董事长']
                },
                {
                    name: '倪建达',
                    photo: '',
                    intro: ['钜派投资集团联席董事长兼CEO']
                },
                {
                    name: '潘维明',
                    photo: '',
                    intro: ['原上海市委宣传部部长']
                },
                {
                    name: '任汇川',
                    photo: '',
                    intro: ['中国平安集团总经理']
                },
                {
                    name: '任志强',
                    photo: '',
                    intro: ['原华远集团董事长']
                },
                {
                    name: '邵云东',
                    photo: '',
                    intro: ['浙江天草生物股份有限公司董事长']
                },
                {
                    name: '沈飞宇',
                    photo: '',
                    intro: ['美林阁集团董事局主席','莫泰酒店创始人']
                },
                {
                    name: '孙恒志',
                    photo: '',
                    intro: ['原中共上海市委研究室主任']
                },
                {
                    name: '孙峥',
                    photo: '',
                    intro: ['第一财经财务总监']
                },
                {
                    name: '汪潮涌',
                    photo: '',
                    intro: ['信中利资本集团创始人','董事长兼总裁']
                },
                {
                    name: '汪荣明',
                    photo: '',
                    intro: ['华东师范大学副校长']
                },
                {
                    name: '王力群',
                    photo: '',
                    intro: ['磐石资本董事长']
                },
                {
                    name: '王红新',
                    photo: '',
                    intro: ['原上海交通大学海外教育学院执行院长','娃哈哈福礼惠董事长']
                },
                {
                    name: '王均豪',
                    photo: '',
                    intro: ['均瑶集团创始人&总裁']
                },
                {
                    name: '王开国',
                    photo: '',
                    intro: ['原海通证券董事长']
                },
                {
                    name: '王仁定',
                    photo: '',
                    intro: ['新沪商大商学院院长']
                },
                {
                    name: '王少钦',
                    photo: '',
                    intro: ['安信信托董事长']
                },
                {
                    name: '王笙',
                    photo: '',
                    intro: ['北京明通四季科技有限公司创始人']
                },
                {
                    name: '卫哲',
                    photo: '',
                    intro: ['嘉御基金创始合伙人兼董事长']
                },
                {
                    name: '徐子望',
                    photo: '',
                    intro: ['原高盛合伙人&CXC创投董事长']
                },
                {
                    name: '阎焱',
                    photo: '',
                    intro: ['赛富亚洲投资基金创始管理合伙人']
                },
                {
                    name: '袁芳',
                    photo: '',
                    intro: ['贝因美集团董事长']
                },
                {
                    name: '翟俊生',
                    photo: '',
                    intro: ['苏州国发集团总经理']
                },
                {
                    name: '张甬江',
                    photo: '',
                    intro: ['浙江恒励置业集团有限公司总裁']
                },
                {
                    name: '张醒生',
                    photo: '',
                    intro: ['大自然保护协会亚太区首席代表','道同资本创始合伙人']
                },
                {
                    name: '张德旺',
                    photo: '',
                    intro: ['上海创业接力科技金融集团董事长']
                },
                {
                    name: '张炜',
                    photo: '',
                    intro: ['东方明珠集团总裁']
                },
                {
                    name: '赵民',
                    photo: '',
                    intro: ['正略集团创始人&董事长']
                },
                {
                    name: '赵长甲',
                    photo: '',
                    intro: ['长甲集团国际控股有限公司董事长']
                },
                {
                    name: '赵明',
                    photo: '',
                    intro: ['杭州莱凡网络科技有限公司CEO']
                },
                {
                    name: '郑永刚',
                    photo: '',
                    intro: ['杉杉集团创始人&杉杉控股董事局主席']
                },
                {
                    name: '周忻',
                    photo: '',
                    intro: ['易居（中国）控股有限公司董事长']
                },
                {
                    name: '朱民阳',
                    photo: '',
                    intro: ['世界运河文化城市联盟主席']
                },
                {
                    name: '朱小华',
                    photo: '',
                    intro: ['原光大集团董事长']
                },
                {
                    name: '卓福民',
                    photo: '',
                    intro: ['源星资本董事长&管理合伙人']
                },
            ];
            let len = arr.length;
            for(let i=0; i<len; i++){
                arr[i].photo = require('./guest'+(i+1)+'.png');
                // console.log(arr);
            }
            return arr;
        },
        //tab切换
        clickTabHandle(index){
            this.activeIndex = index;
        },
        //点击放大图片
        scaleImgHandle(index){
            this.showMask = true;
            console.log(index);
            this.showIndex = index;
        },
        //上一张
        prevBtnClick(){
            if(this.showIndex > 0){
                this.showIndex--;
            }else{
                this.showIndex = 5;
            }
            // console.log('prevIndex::',this.showIndex);
        },
        //下一张
        nextBtnClick(){
            if(this.showIndex >= 0 && this.showIndex < 5){
                this.showIndex++;
            }else{
                this.showIndex = 0;
            }
            // console.log('nextIndex::',this.showIndex);
        },
        //关闭弹出层
        closePop(){
            this.showMask = false;
        },
        jump(index){
            // console.log('index: '+ index);
            let jump = document.querySelectorAll('.content');
            let total = jump[index].offsetTop - 100;
            let distance = document.documentElement.scrollTop-100 || document.body.scrollTop-100;
            // console.log("要滚动到的对应高度： "+total + ", 滚动条目前所处的高度："+distance);
            //平滑滚动 时长500ms，每10ms一跳 共50跳
            let step = total / 50;
            if(total > distance){
                smoothDown();
            }else{
                let newTotal = distance - total;
                step = newTotal / 50;
                smoothUp();
            }
            function smoothDown(){
                if(total > distance){
                distance += step;
                document.body.scrollTop = distance;
                document.documentElement.scrollTop = distance;
                // window.pageYOffset = distance;
                setTimeout(smoothDown, 10);
                }else{
                document.body.scrollTop = total;
                document.documentElement.scrollTop = total;
                // window.pageYOffset = total;
                }
            }
            function smoothUp(){
                if(distance > total){
                distance -= step;
                document.body.scrollTop = distance;   //Chrome
                document.documentElement.scrollTop = distance;   //Firefox
                window.pageYOffset = distance;     //Safari
                setTimeout(smoothUp, 10);
                }else{
                document.body.scrollTop = total;
                document.documentElement.scrollTop = total;
                // window.pageYOffset = total;
                }
            }
            this.isActive = index;
            },
        mouseoverHandle(){
            console.log('over');
            this.slideDown = true;
        },
        mouseoutHandle(){
            this.slideDown = false;
        },
    }
}
</script>
<style scoped>
.header{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 104px;
  background: #F3F3F3;
  padding: 14px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #ddd;
  z-index: 99;
}
.header .header-main{
  width: 1200px;
  height: 100%;
  margin: 0 auto;
}

.header .thirty-year{
  position: absolute;
  top: -8px;
  right: 12%;
}
.header.active{
  background: #333367;
}
.header .logo-icon{
  width: 20%;
}
.header .logo{
    cursor: pointer;
}
.header ul{
  display: table;
  table-layout: fixed;
  width: 70%;
  height: 76px;
  padding-left: 4%;
  box-sizing: border-box;
}
.header ul.pt{
    padding-top: 15px;
}
.header li{
  display: table-cell;
  /* width: 8.75%; */
  min-width: 104px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  color: #000;
  font-size: 18px;
  cursor: pointer;
  position: relative;
}
.header li.active{
  color: #3386ff;
}
.header .catalogArrow{
    position: absolute;
    bottom: -13px;
    left: 50%;
    transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    background: #3386ff;
    height: 5px;
    width: 80px;
}
.header li{
  font-size: 17px;
}
.header .navlist{
  position: relative;
}
.header .navlist > span{
  background: url('./slide-gray.png') no-repeat 0 0;
  display: inline-block;
  width: 11px;
  height: 7px;
  vertical-align: middle;
  background-size: 11px 7px;
}
.header .second-list{
  position: absolute;
  width: 132px;
  top: 60px;
  right: 2px;
  height: 100px;
  display: block;
  background: #232323;
  padding: 10px 0;
  z-index: 9;
}
.header .second-list li{
    float: left;
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
}
.second-list span{
    transition: all 0.5s;
    -webkit-transition: all 0.5s;
}
.header .second-list a{
    color: #B8B8B8;
}
.second-list li:hover a{
    color: #ffffff;
}
.slideToggle-enter-active, .slideToggle-leave-active{
    transition: all 0.4s ease;
}
.slideToggle-enter,.slideToggle-leave-to{
    height: 0;
    opacity: 0;
}
.slideToggle-enter-to,.slideToggle-leave{
    height: 80px;
    opacity: 1;
}
.banner{
    width: 100%;
    min-width: 1200px;
    height: 682px;
    margin-top: 104px;
    background: url('./banner.png') no-repeat center 0;
    background-size: cover;
}
.keyWordContent{
    padding-bottom: 12px;
    min-width: 1200px;
}
.keyWordContent .keywords{
    margin: -210px auto;
    margin-bottom: 30px;
    width: 1118px;
    height: 598px;
    background: #fff;
    padding: 30px 108px;
    box-sizing: border-box;
    border-radius: 20px;
    box-shadow: 0 0 10px 4px rgba(51,51,102,0.1);
    -webkit-box-shadow: 0 0 10px 4px rgba(51,51,102,0.1);
    -moz-box-shadow: 0 0 10px 4px rgba(51,51,102,0.1);
}
.keywords .tit, .guests .tit, .viewpointMain .tit, .pictureMain .tit{
    height: 160px;
    line-height: 160px;
    position: relative;
    margin-bottom: 15px;
}
.keywords .keyWordsImg{
    position: absolute;
    top: 10px;
    left: 90px;
}
.keywords .tit span, .guests .tit span, .viewpointMain .tit span, .pictureMain .tit span{
    font-size: 36px;
    vertical-align: top;
    margin: 0 10px;
}
.keywords .tit img, .guests .tit img, .viewpointMain .tit img, .pictureMain .tit img{
    vertical-align: middle;
}
.keywords .info{
    position: relative;
    margin-bottom: 30px;
}
.keywords .info .text{
    font-size: 20px;
    color: #010000;
    line-height: 32px;
    text-align: justify;
    padding: 30px 30px;
}
.keywords .info img{
    position: absolute;
}
.keywords .info .symbol1{
    top: 0;
    left: -20px;
}
.keywords .info .symbol2{
    bottom: -10px;
    right: -20px;
}
.keywords .founder{
    color: #666;
}
.keywords .founder .photoChen{
    margin-right: 20px;
}
.keywords .founder h1{
    font-size: 36px;
    font-weight: 600;
    line-height: 42px;
}
.keywords .founder h3,.keywords .founder p{
    font-size: 16px;
}
.keywords .founder h3{
    margin: 5px 0 16px 0;
    font-weight: 600;
    letter-spacing: 1px;
}
.keywords .textAlignL{
    text-align: left;
    width: 130px;
}
.keyWordContent .video{
    width: 1430px;
    /* width: 75%; */
    min-width: 1200px;
    margin: 28px auto;
}
.video .position{
    position: relative;
}
.video .position a{
    display: inline-block;
}
/* .video .position .autoWidth{
    width: 100%;
    height: 100%;
} */
/* .video .position video{
    width: 100%;
    height: 100%;
} */

.video .column{
    /* width: 35%; */
    /* display: flex;
    display:-webkit-flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: space-between; */
}
.video .row{
    /* width: 64.5%; */
    /* width: 918px;
    height: 578px; */
}
/* .video .playIcon{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
} */
.video .tips{
    position: absolute;
    left: 36px;
    bottom: 32px;
    text-align: left;
    color: #fff;
    font-size: 22px;
}
.video .line{
    width: 60px;
    height: 4px;
    background: #3585ff;
    margin: 15px 0;
}
.video .fontBold{
    font-weight: 600;
}
.anniversary .guests{
    background: #fff;
    min-width: 1200px;
}
.anniversary .guestsMain{
    width: 1020px;
    margin: 0 auto;
}
.anniversary .guests ul,.anniversary .picture .tabList,.pictureList ul{
    width: 1020px;
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
}
.anniversary .guests li{
    position: relative;
    width: 300px;
    height: 132px;
    background: #fff;
    border-radius: 8px;
    margin-bottom: 40px;
    box-shadow: 0 0 10px 5px rgba(57, 156, 255, .1);
    -webkit-box-shadow: 0 0 10px 5px rgba(57, 156, 255, .1);
    -moz-box-shadow: 0 0 10px 5px rgba(57, 156, 255, .1);
}
.anniversary .guests .photo{
    position: absolute;
    top: -20px;
    left: -20px;
}
.guests .guestIntro{
    padding: 12px 26px 0 100px;
    text-align: left;
    color: #666;
}
.guests .guestIntro h2{
    font-weight: 600;
    font-size: 24px;
    margin-bottom: 14px;
}
.guests .guestIntro p{
    font-size: 14px;
    margin-bottom: 8px;
    line-height: 18px;
}
.anniversary .viewpoint{
    height: 556px;
}
.viewpoint .cardBox{
    width: 1200px;
    margin: 0 auto;
}
.anniversary .picture{
    width: 1180px;
    margin: 0 auto 60px;
}
.anniversary .picture .tabList{
    color: #666;
    width: 825px;
    margin: 0 auto 56px;
}
.anniversary .picture .activeStyle{
    color: #3485ff;
}
.picture li{
    cursor: pointer;
}
.picture .tabList li{
    font-size: 26px;
}
.pictureList ul{
    width: 100%;
}
.pictureList ul li{
    margin-bottom: 30px;
}
.anniversary .footer{
    background: #fff;
}
.anniversary .abc-info{
    width: 100%;
    font-size: 14px;
    color: #000;
}
.anniversary .abc-info .font-bold span{
    font-weight: 600;
}
.anniversary .font-bold span:first-child {
    margin-right: 22px;
}
.anniversary .abc-info a{
    color: #000;
}
.anniversary .abc-info .logoList a:hover{
    background: #e5e5e5;
}

.mask{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}
.mask .popup{
  /* width: 55%;
  height: 80%;
  min-width: 898px; */
  /* background: #fff; */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.mask .popup img{
    width: 100%;
}
.mask .close{
  position: fixed;
  top: -36px;
  right: -36px;
  background: url('./icon-close2.png') no-repeat 0 0;
  width: 72px;
  height: 72px;
  cursor: pointer;
  z-index: 9;
}
.mask .btn{
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    color: #eee;
    font-size: 26px;
    font-weight: 600;
    background: rgba(0, 0, 0, .5);
    font-family: "宋体";
    cursor: pointer;
}
.mask .btn:hover{
    background: rgba(0, 0, 0, .8);
}
.mask .prevBtn{
    left: -50px;
}
.mask .nextBtn{
    right: -100px;
}
.fade-enter-active,.fade-leave-active{
  transition: all 0.5s;
}
.fade-enter,.fade-leave-to{
  opacity: 0;
}
.footer{
    padding: 20px 0;
}
.footer .footer-box{
    max-width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
}
.abc-info .logoList a{
    display: inline-block;
    width: 190px;
    height: 60px;
}
.abc-info .logoList a:hover{
    background: rgba(255, 255, 255, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/anniversary/anniversary.vue